import makeContainer from 'core/display/simple/Container'
import makeGraphics from 'core/display/simple/Graphics'
import { enableDrag } from 'core/handlers/DragHandler'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { scroll, view } from 'settings/base'

import { Device } from '../../utils/Device'

export function enableScroll(object) {
  signal.once('ACTION:SETUP', rechild)
  signal.on('RADIO:menu', reset)

  const platform = Device.isDesktop() ? 'desktop' : 'mobile'
  const scrollable = new makeContainer()
  const mask = new makeGraphics({ x: 0, y: 0, width: view[platform].land.width, height: 1 })

  enableDrag(scrollable, { start, move, stop })

  let prev
  let click

  function start(point) {
    click = true
    prev = point
  }

  function move(point) {
    click = click && point.equals(prev)
    scrollable.y = cap(scrollable.y + (point.y - prev.y) * devicePixelRatio)
    prev = point
  }

  function stop() {
    const action = +click * Math.sign(0.5 - mask.toLocal(prev).y)
    const y = cap(scrollable.y + action * mask.height)
    const stopTween = gsap.to(scrollable, 0.3, { y,  onComplete: () => stopTween.kill })
  }

  function cap(y) {
    return y > mask.y
      ? mask.y
      : y < mask.y + mask.height - scrollable.height
        ? mask.y + mask.height - scrollable.height
        : y
  }

  function reset() {
    scrollable.y = mask.y
  }

  function resize({ orientation, stage, scale, screen }) {
    mask.y = (stage.height * scale - screen.height) / 2 / scale
    mask.height = (screen.height - (scroll[platform][orientation] + object.y) * scale) / scale
    scrollable.y = cap(scrollable.y)
  }

  function rechild() {
    scrollable.addChild(...object.children)
    object.addChild(scrollable, mask)
    object.mask = mask
    signal.on('RESIZE', resize)
  }
}
